<template>
  <section id="teacher-login">
    <b-field label="Username">
      <b-input
        required
        maxlength="50"
        placeholder="Username"
        v-model="username"
      ></b-input>
    </b-field>

    <b-field label="Password">
      <b-input
        type="password"
        placeholder="Password"
        required
        password-reveal
        v-model="password"
      ></b-input>
    </b-field>

    <b-button
      type="is-primary"
      class="mt-4"
      :loading="isLoading"
      @click="login"
    >
      Login
    </b-button>
  </section>
</template>

<script>
import SACFrontendService from "@/services/SACFrontendService";
import { mapActions } from "vuex";

export default {
  components: {},
  name: "TeacherLogin",
  data() {
    return {
      username: "",
      password: "",
      isLoading: false,
    };
  },

  methods: {
    ...mapActions(["updateTeacherId"]),

    async login() {
      this.isLoading = true;
      try {
        await SACFrontendService.login(this.username, this.password);

        // Save teacherId to store after successful login
        const teacherInfo = SACFrontendService.teacherInfo();
        if (teacherInfo.teacherId) {
          this.updateTeacherId(teacherInfo.teacherId);
        }

        this.$router.push({ name: "TeacherHome" });
      } catch (error) {
        console.error(error);
        this.$buefy.toast.open({
          message: "Login failed. Please check your credentials.",
          type: "is-danger",
        });
      } finally {
        this.isLoading = false;
      }
    },
  },

  mounted() {
    const isAuthenticated = SACFrontendService.isAuthenticated();
    if (!isAuthenticated) {
      return;
    }

    // Save teacherId to store if already authenticated
    const teacherInfo = SACFrontendService.teacherInfo();
    if (teacherInfo.teacherId) {
      this.updateTeacherId(teacherInfo.teacherId);
    }

    this.$router.replace({ name: "TeacherHome" });
  },
};
</script>

<style scoped>
#teacher-login {
  background-color: white;
  width: 320px;
  min-height: 280px;
  padding: 1rem;
  margin-top: 5rem;
  margin-bottom: 10rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}
.login-card {
  width: 350px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}
.header h2 {
  font-size: 20px;
  font-weight: bold;
  margin-top: 0.5rem;
}
.custom-field >>> label {
  text-align: left;
  display: block;
  font-weight: bold;
}
.login-button {
  width: 100%;
}
</style>
